import React, { useEffect, useRef } from 'react'
import styles from '../styles/modal.module.css'
import { IoAdd } from "react-icons/io5";
import { IoCloseOutline } from "react-icons/io5";

const Links = ({ link, setLink, links, setLinks, close, disabled, open }) => {

    const inputRef = useRef(null);

    useEffect(() => {
        if(inputRef.current){
            inputRef.current.focus();
        }
    })


    return (
        <>
            <div className={styles.head}>
                <h3>Add Links</h3>
                <i className={`bx bx-x ${styles.close}`} onClick={() => { close({ component: '', open: false }) }}></i>
            </div>
            <div className={styles.small_container}>
                <form onSubmit={(e) => { e.preventDefault(); setLinks((prev) => [...prev, link]); setLink(''); disabled(false) }} className="row align-items-center mb-2">
                    <div className="col-10">
                        <div className="inputField mb-0">
                            <input type="text" ref={inputRef} name='links' value={link} placeholder='Enter a Link' onChange={(e) => { setLink(e.target.value); disabled(false) }} required />
                        </div>
                    </div>
                    <div className="col-2">
                        <button type='submit' className={styles.icon} data-attr="Add More">
                            <IoAdd />
                        </button>
                    </div>
                </form>
                <ul className={styles.upload_items}>
                    {links.length > 0 && links.map((item, index) => {
                        return <li key={index}><span>{item}</span> <IoCloseOutline onClick={() => { setLinks((prev) => prev.filter((i) => i !== item)) }} className={styles.close} /></li>
                    })}
                </ul>
            </div>
            <div className={styles.foot}>
                <div className="d-flex align-items-center" style={{ gap: "20px" }}>
                    <button type='button' onClick={() => { close({ component: '', open: false }); if (link !== "") { setLinks((prev) => [...prev, link]); setLink("") }; }} className={`button2`}>Save</button>
                </div>
            </div>
        </>
    )
}

export default Links
